import store from "../store/index";
// Unauthenticated pages
import DesignUpdateLayout from "@/pages/Dashboard/Layout/DesignUpdateLayout.vue";
import NoAuthLayout from "@/pages/Dashboard/Layout/NoAuthLayout.vue";
// import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";
// import AuthLayout from "@/pages/Dashboard/Pages/AuthLayout.vue";

// Privacy
import Privacy from "@/pages/Dashboard/Pages/Legal/Privacy.vue";
import PrivacyPolicy from "@/pages/Dashboard/Pages/Legal/Privacy/PrivacyPolicy.vue";
import CookiePolicy from "@/pages/Dashboard/Pages/Legal/Privacy/CookiePolicy.vue";
import PixelPartners from "@/pages/Dashboard/Pages/Legal/Privacy/PixelPartners.vue";
import TermsofUse from "@/pages/Dashboard/Pages/Legal/TermsofUse.vue";

import Logout from "@/pages/Dashboard/Pages/Logout";
import Login from "@/pages/Dashboard/Pages/Login";
import SmartLinks from "@/pages/Dashboard/Pages/SmartLinks";
import SmartLink from "@/pages/Dashboard/Pages/SmartLink";
import Register from "@/pages/Dashboard/Pages/Register";
import Settings from "@/pages/Dashboard/Pages/Settings";
import Signup from "@/pages/Dashboard/Pages/Signup";
import CompleteRegistration from "@/pages/Dashboard/Pages/CompleteRegistration";
import Homepage from "@/pages/Dashboard/Pages/Homepage2";
import Drops from "@/pages/Dashboard/Pages/Drops";
import Messages from "@/pages/Dashboard/Pages/Messages";
import AddArtist from "@/pages/Dashboard/Pages/AddArtist";
import ReactivateSubscription from "@/pages/Dashboard/Pages/ReactivateSubscription";
import Billing from "@/pages/Dashboard/Pages/Billing";
import ChangeSubscription from "@/pages/Dashboard/Pages/ChangeSubscription";
import ForgotPassword from "@/pages/Dashboard/Pages/ForgotPassword";
import ResetPassword from "@/pages/Dashboard/Pages/ResetPassword";
import ResetPasswordAdmin from "@/pages/Dashboard/Pages/ResetPasswordAdmin";
import RedirectCo from "@/components/RedirectCo";
import Blog from "@/pages/Dashboard/Pages/Blog/Blog.vue";
import BlogPost from "@/pages/Dashboard/Pages/Blog/Post.vue";
import Feedback from "@/pages/Dashboard/Pages/Feedback";
import Coupon from "@/pages/Dashboard/Pages/Coupon";
import Referrals from "@/pages/Dashboard/Pages/Referrals";

const routes = [
  {
    path: "/",
    component: NoAuthLayout,
    beforeEnter: noAuthCheck,
    children: [
      {
        path: "/",
        name: "Homepage",
        components: { default: Homepage }
      },
      {
        path: "/login",
        name: "Login",
        components: { default: Login },
        props: {
          default: true
        }
      },
      {
        path: "/forgot-password",
        name: "ForgotPassword",
        component: ForgotPassword
      },
      {
        path: "/reset-password",
        name: "Reset Password",
        component: ResetPassword
      },
      {
        path: "/reset-password-admin",
        name: "Reset Password - Admin",
        component: ResetPasswordAdmin
      },
      {
        path: "/complete-registration",
        name: "CompleteRegistration",
        component: CompleteRegistration
      },
      {
        path: "/register",
        name: "Register",
        component: Register
      },
      {
        path: "/artist/:artistID",
        name: "RedirectCo",
        component: RedirectCo
      },
      {
        path: "/blog",
        name: "Blog",
        component: Blog
      },
      {
        path: "/blog/:slug/",
        name: "BlogPost",
        component: BlogPost
      },
      {
        path: "/r/:coupon/",
        name: "Coupon",
        component: Coupon
      },
      {
        path: '/ARISTAKE',
        redirect: '/r/ARISTAKE'
      }
    ]
  },
  {
    path: "/signup",
    name: "Signup",
    beforeEnter: (to, from, next) => {
      if (store.state.user?.id && store.state.user.signup_finished) {
        next({ name: "SmartLinks" });
      } else {
        next();
      }
    },
    component: Signup
  },
  {
    path: "/logout",
    name: "Logout",
    component: Logout
  },
  {
    path: "/",
    component: DesignUpdateLayout,
    meta: { requiresLogin: true },
    beforeEnter: authCheck,
    children: [
      {
        path: "add-artist",
        name: "AddArtist",
        components: { default: AddArtist }
      },
      {
        path: "reactivate-subscription",
        name: "ReactivateSubscription",
        components: { default: ReactivateSubscription }
      },
      {
        path: "change-subscription",
        name: "ChangeSubscription",
        components: { default: ChangeSubscription }
      },
      {
        path: "billing",
        name: "Billing",
        components: { default: Billing }
      },
      {
        path: "feedback",
        name: "Feedback",
        components: { default: Feedback }
      },
      {
        path: "feedback/*",
        name: "FeedbackAll",
        components: { default: Feedback }
      },
      {
        path: "links",
        name: "SmartLinks",
        components: { default: SmartLinks }
      },
      {
        path: "links/:id",
        name: "SmartLink",
        components: { default: SmartLink }
      },
      {
        path: "drops",
        name: "Drops",
        components: { default: Drops }
      },
      {
        path: "messages",
        name: "Messages",
        components: { default: Messages }
      },
      {
        path: "settings",
        name: "Settings",
        components: { default: Settings }
      },
      {
        path: "referrals",
        name: "Referrals",
        components: { default: Referrals }
      }
    ]
  },
  {
    path: "/legal/privacy",
    name: "Privacy",
    component: Privacy
  },
  {
    path: "/legal/terms-of-use",
    name: "Terms of Use",
    component: TermsofUse
  },
  {
    path: "/legal/privacy/privacy-policy",
    name: "Privacy Policy",
    component: PrivacyPolicy
  },
  {
    path: "/legal/privacy/cookie-policy",
    name: "Privacy / Cookie Policy",
    component: CookiePolicy
  },
  {
    path: "/legal/privacy/pixel-partners",
    name: "Privacy / Pixel Partners",
    component: PixelPartners
  },
  { path: "*", redirect: "/" }
];

/*
  This will check to see if the user is logged in or not.
*/
function authCheck(to, from, next) {
  // console.log({ store, to, from, next });
  // next();
  if (!store.state.user?.id) {
    console.log("go to login to continue...");
    next({ name: "Login" });
  } else if (
    store.state.user?.id &&
    store.state.user.signup_finished === false
  ) {
    console.log("go to signup to continue...");
    next({ name: "Signup" });
  } else {
    if (store.state.signup.id) store.commit("signup/reset");
    next();
  }
}

/*
  This will check to see if the user is logged in or not.
*/
function noAuthCheck(to, from, next) {
  if (store.state.user && store.state.user.signup_finished === false) {
    next({ name: "Signup" });
  } else if (store.state.user?.id) {
    next({ name: "SmartLinks" });
  } else {
    next();
  }
}

export default routes;
